import { apiInternetBase, HttpType } from "gf-ui";

class apiAutocompletes extends apiInternetBase {
    constructor(dispatch, apiCallback, token){
        super(dispatch, apiCallback, token, "/autocomplete")
    }        
   
    #comuni        = (token, cb) => this._getJson(HttpType.POST, `/comuni`,  cb, token);    
    #tipiUtentiWeb = (token, cb) => this._getJson(HttpType.POST, `/tipi-utenti-web`,  cb, token);    
        
    fnComuni = (fnReturn, params) => {
        this.setParams(params)
        this.#comuni(this.token, (status, res) => this.apiCallback(status, res, fnReturn))
    }    

    fnTipiUtentiWeb = (fnReturn, params) => {
        this.setParams(params)
        this.#tipiUtentiWeb(this.token, (status, res) => this.apiCallback(status, res, fnReturn))
    }    
}

export default apiAutocompletes;